import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, HostListener, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RestDataService } from '../../service/rest-data.service';
import { Config } from '../../config/config';
import { StaticDataService } from '../../service/static-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: '.app-zone-view',
  templateUrl: './zone-view.component.html',
  styleUrls: ['./zone-view.component.css']
})
export class ZoneViewComponent implements OnInit, AfterViewInit {

  @Input() name: string;
  @Input() zoneData: any;
  @Input() elementsToExclude: any[];
  @Input() componentDesigns: any[];
  editCollection = false;
  collectionData = {};
  @Output() updateZone = new EventEmitter<any>();

  @ViewChild('rootZone',{static: false}) rootZone: ElementRef;

  metaPopup = false;
  previewMetaData = null;
  lastSavedMeta = null;
  idForMeta = null;
  metaOptions = ['SECTION', 'SUBSECTION', 'TOPIC'];
  optionOfMeta = '';
  metaQuery: FormControl = new FormControl();
  compareFn = this._compareFn.bind(this);
  listArray = [];
  @ViewChildren('pageInput') pageField;
  @ViewChild('pageList',{static: false}) pageList;
  insidePageField = false;
  currentSelection = 0;
  constructor(
    private restService: RestDataService,
    private config: Config,
    private sharedService: SharedDataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.metaQuery.valueChanges
      .pipe(debounceTime(200)
      ,distinctUntilChanged())
      .subscribe(result => {
        if (this.metaPopup) {
          this.searchResults(result, data => {
            if (!data.hasOwnProperty('error') && data.hasOwnProperty('content')) {
              this.listArray = data['content'];
            }
          });
        }
      });
    if (!this.zoneData.elements || this.zoneData.elements === null) {
      this.zoneData.elements = [];
    } else {
      this.getAllCollectionData(this.zoneData.elements);
    }
    if (this.zoneData.elementProperties === null) {
      this.zoneData.elementProperties = {};
    }
  }

  searchResults(text, callback) {
    let url = this.config.get('product').baseUrl
      + '/api/cms/page/search?size=15&page=0&sort=lastModifiedDate,desc&search=status:PUBLISHED,pageType!PRIMARY';
    if (text && text.trim() !== '') {
      url += ',name~' + StaticDataService.encodeSpecialChar(text);
    }
    if (this.optionOfMeta) {
      url += ',pageType:' + this.optionOfMeta;
    }
    url += '&fields=reusable,metadata.markUnimportant,metadata.killed,metadata.tags,metadata.breakingNews,metadata.sponsored,lockedByUserId,id,status,name,url,lastModifiedDate,lastModifiedByUserName,pageType';

    this.restService.http_get(url)
      .subscribe(data => {
        callback(data);
      });
  }

  ngAfterViewInit() {
    this.rootZone.nativeElement.parentElement.addEventListener('drop', this.dropDetect.bind(this));
  }

  openPopup() {
    this.editCollection = true;
  }

  closePopup() {
    this.editCollection = false;
  }

  setCollections(ev) {
    this.zoneData.elements = ev;
    this.checkPropertiesOfElements(ev);
    this.getAllCollectionData(ev);
    setTimeout(e => {
      this.updateZone.emit(this.zoneData);
    }, 2);
  }

  checkPropertiesOfElements(ev) {
    for (const id of ev) {
      if (!this.zoneData.elementProperties.hasOwnProperty(id)) {
        this.zoneData.elementProperties[id] = {
          design: '',
          sectionId: '',
          subSectionId: '',
          topicId: '',
          section: '',
          subSection: '',
          topic: '',
          limit: 0
        };
      }
    }
  }

  clearCollections() {
    this.zoneData.elements = [];
    this.zoneData.elementProperties = {};
    setTimeout(e => {
      this.updateZone.emit(this.zoneData);
    }, 2);
  }

  getAllCollectionData(arr) {
    if (arr && arr.length > 0) {
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.story_page_id, StaticDataService.element_byids_api),
        arr,
        res => {
          for (const element of res) {
            this.collectionData[element.id] = element;
          }
        });
    }
  }

  dragStart(ev) {
    this.sharedService.dragValue = ev.target.id;
  }

  dropDetect(ev) {
    // console.log(ev);
    setTimeout(e => {
      this.getAllCollectionData(this.zoneData.elements);
    }, 300);
  }

  openCollection(id) {
    this.router.navigate(['./dash/element/' + id]);
  }

  deleteCollection(id) {
    const index = this.zoneData.elements.indexOf(id);
    if (index > -1) {
      this.zoneData.elements.splice(index, 1);
      delete this.zoneData.elementProperties[id];
      setTimeout(e => {
        this.updateZone.emit(this.zoneData);
      }, 2);
    }
  }

  openElementMeta(id) {
    if (!this.zoneData.elementProperties.hasOwnProperty(id)) {
      this.zoneData.elementProperties[id] = {
        design: '',
        sectionId: '',
        subSectionId: '',
        topicId: '',
        section: '',
        subSection: '',
        topic: '',
        limit: 0
      };
    }
    if (this.zoneData.elementProperties[id].sectionId !== '' && this.zoneData.elementProperties[id].sectionId !== null) {
      this.optionOfMeta = 'SECTION';
      this.metaQuery.setValue(this.zoneData.elementProperties[id].section);
    } else if (this.zoneData.elementProperties[id].subSectionId !== '' && this.zoneData.elementProperties[id].subSectionId !== null) {
      this.optionOfMeta = 'SUBSECTION';
      this.metaQuery.setValue(this.zoneData.elementProperties[id].subSection);
    } else if (this.zoneData.elementProperties[id].topicId !== '' && this.zoneData.elementProperties[id].topicId !== null) {
      this.optionOfMeta = 'TOPIC';
      this.metaQuery.setValue(this.zoneData.elementProperties[id].topic);
    } else {
      this.optionOfMeta = 'SECTION';
      this.metaQuery.setValue('');
    }

    this.idForMeta = id;
    this.previewMetaData = JSON.parse(JSON.stringify(this.zoneData.elementProperties[id]));
    this.lastSavedMeta = JSON.parse(JSON.stringify(this.zoneData.elementProperties[id]));
    this.metaPopup = true;
  }

  saveElementMeta() {
    const change = this.sharedService.getDifference(JSON.stringify(this.previewMetaData), JSON.stringify(this.lastSavedMeta));
    if (change !== '') {
      this.zoneData.elementProperties[this.idForMeta] = JSON.parse(JSON.stringify(this.previewMetaData));
      setTimeout(e => {
        this.updateZone.emit(this.zoneData);
        this.closeElementMeta();
      }, 2);
    } else {
      this.closeElementMeta();
    }
  }

  closeElementMeta() {
    this.metaPopup = false;
    this.idForMeta = null;
    this.previewMetaData = null;
    this.lastSavedMeta = null;
    this.optionOfMeta = '';
    this.metaQuery.setValue('');
    this.listArray = [];
    this.insidePageField = false;
    this.currentSelection = 0;
  }

  onChange(ev) {
    console.log(ev);
    this.previewMetaData.sectionId = null;
    this.previewMetaData.section = null;
    this.previewMetaData.subSectionId = null;
    this.previewMetaData.subSection = null;
    this.previewMetaData.topicId = null;
    this.previewMetaData.topic = null;
    this.metaQuery.setValue('');
    this.searchResults('', data => {
      if (!data.hasOwnProperty('error') && data.hasOwnProperty('content')) {
        this.listArray = data['content'];
      }
    });
  }

  _compareFn(a, b) {
    return a === b;
  }

  focusInSuggest(model) {
    if (model === 'page') {
      this.insidePageField = true;
    }
    this.currentSelection = 0;
    this.filterAutoCompleteUp({ keyCode: 0 }, model);
  }


  focusOutSuggest(model) {
    // console.log('fout callled');
    if (model === 'page') {
      this.insidePageField = false;
      this.listArray = [];
    }
  }

  filterAutoCompleteUp(event, model) {
    // console.log(event);
    // console.log(model);
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
      if (model === 'page') {
        // console.log('inside => ' + this.insideSection);
        if (!this.insidePageField) {
          this.insidePageField = true;
          this.searchResults('', data => {
              if (!data.hasOwnProperty('error') && data.hasOwnProperty('content')) {
                this.listArray = data['content'];
              }
            });
        }
      }
    }
    // this.currentSelection = 0;
    return true;
  }


  filterAutoCompleteDown(event, model) {
    if (event.key === 'Enter') {
      if (model === 'page') {
        this.insidePageField = false;
        this.selectAutoComplete(model, this.listArray[this.currentSelection]);
      }
    } else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'page') {
        if (this.currentSelection < (this.listArray.length - 1)) {
          this.currentSelection += 1;
          this.pageList.nativeElement.scrollBy(0, 23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insidePageField = false;
      event.stopPropagation();
    } else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'page') {
          this.pageList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    } else if (event.keyCode === 9) {
      // console.log('tab on ' + model);
      if (this.insidePageField) {
        this.focusOutSuggest(model);
      }
    } else {
      this.currentSelection = 0;
    }
    // console.log(this.currentSelection);
    return true;
  }

  selectAutoComplete(model, item) {
    if (model === 'page') {
      this.metaQuery.setValue(item.name);
      if (item.pageType === 'SECTION') {
        this.previewMetaData.sectionId = item.id;
        this.previewMetaData.section = item.name;
        this.previewMetaData.subSectionId = null;
        this.previewMetaData.subSection = null;
        this.previewMetaData.topicId = null;
        this.previewMetaData.topic = null;
      } else if (item.pageType === 'SUBSECTION') {
        this.previewMetaData.sectionId = null;
        this.previewMetaData.section = null;
        this.previewMetaData.subSectionId = item.id;
        this.previewMetaData.subSection = item.name;
        this.previewMetaData.topicId = null;
        this.previewMetaData.topic = null;
      } else if (item.pageType === 'TOPIC') {
        this.previewMetaData.sectionId = null;
        this.previewMetaData.section = null;
        this.previewMetaData.subSectionId = null;
        this.previewMetaData.subSection = null;
        this.previewMetaData.topicId = item.id;
        this.previewMetaData.topic = item.name;
      }
      this.listArray = [];
    }
  }

  @HostListener('window:keydown', ['$event'])
  public hotkeysdown($event) {
    const key = $event.keyCode || $event.charCode;
    const focusedElement: HTMLElement = document.activeElement as HTMLElement;
    if (key === 27) {
      if (this.insidePageField) {
        this.insidePageField = false;
      }
    }
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;
    if (this.pageField['_results'][0] && (clickedComponent === this.pageField['_results'][0].nativeElement
    || this.pageList.nativeElement.contains(clickedComponent))) {
      this.insidePageField = true;
    } else {
      this.insidePageField = false;
    }
  }

}
